import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider } from '../../shared/kit';
import App from './App';
import type { ShopMerciInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-shop-merci-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: ShopMerciInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as ShopMerciInitData;
    } catch (error) {
        window.console?.error?.('[gas-shop-merci] init JSON invalide', error);
        initData = {} as ShopMerciInitData;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasToastProvider>
                <App initData={initData} />
            </GasToastProvider>
        </React.StrictMode>,
    );
}
